<template>
  <div>
    <Report-Devices-By-Clients />
  </div>
</template>

<script>
export default {
  components: {
    "Report-Devices-By-Clients": () =>
      import(
        /* webpackChunkName: "ReportDevices" */ "@/views/modules/sales/reports/ReportDevicesByClients"
      )
  }
};
</script>

<style scoped></style>
